import { httpClient as http } from '@/utils/http'
import type {
  PageResponse,
  SupplierQuotationTemplateBindSupplierRequest,
  SupplierQuotationTemplateFieldVO,
  SupplierQuotationTemplateListVO,
  SupplierQuotationTemplateMatchRequest,
  SupplierQuotationTemplatePageRequest,
  SupplierQuotationTemplateSaveRequest,
  SupplierQuotationTemplateSupplierVO,
  SupplierQuotationTemplateUpdateRequest,
  SupplierQuotationTemplateVO
} from './types'

const BASE = '/price/supplier-quotation-template'

/** 分页查询模板列表 */
export const pageSupplierQuotationTemplate = (params: SupplierQuotationTemplatePageRequest) => {
  return http.post<PageResponse<SupplierQuotationTemplateListVO>>(`${BASE}/page`, params)
}

/** 获取模板详情 */
export const getSupplierQuotationTemplate = (id: string | number) => {
  return http.post<SupplierQuotationTemplateVO>(`${BASE}/get`, { id })
}

/** 新建模板 */
export const saveSupplierQuotationTemplate = (params: SupplierQuotationTemplateSaveRequest) => {
  return http.post<boolean>(`${BASE}/save`, params)
}

/** 更新模板 */
export const updateSupplierQuotationTemplate = (params: SupplierQuotationTemplateUpdateRequest) => {
  return http.post<boolean>(`${BASE}/update`, params)
}

/** 删除模板 */
export const deleteSupplierQuotationTemplate = (id: string | number) => {
  return http.post<boolean>(`${BASE}/delete`, { id })
}

/** 批量启用 */
export const batchEnableSupplierQuotationTemplate = (ids: Array<string | number>) => {
  return http.post<boolean>(`${BASE}/batch-enable`, { ids })
}

/** 批量禁用 */
export const batchDisableSupplierQuotationTemplate = (ids: Array<string | number>) => {
  return http.post<boolean>(`${BASE}/batch-disable`, { ids })
}

/** 绑定供应商（全量覆盖，空数组清空） */
export const bindSupplierQuotationTemplateSuppliers = (
  params: SupplierQuotationTemplateBindSupplierRequest
) => {
  return http.post<boolean>(`${BASE}/bind-suppliers`, params)
}

/** 查询模板已绑定供应商 */
export const listSupplierQuotationTemplateSuppliers = (templateId: string | number) => {
  return http.post<SupplierQuotationTemplateSupplierVO[]>(`${BASE}/list-suppliers`, { id: templateId })
}

/** 初始化系统标准模板（幂等，按业务类型各一条） */
export const initializeStandardSupplierQuotationTemplate = () => {
  return http.post<boolean>(`${BASE}/initialize-standard`, {})
}

/** 获取系统标准模板（按业务类型） */
export const getStandardSupplierQuotationTemplate = (businessType: string) => {
  return http.post<SupplierQuotationTemplateVO>(`${BASE}/get-standard`, { businessType })
}

/** 按业务类型查询字段目录（新建模板默认字段） */
export const listSupplierQuotationFieldCatalog = (templateTypes?: string[]) => {
  return http.post<SupplierQuotationTemplateFieldVO[]>(`${BASE}/list-field-catalog`, {
    templateTypes: templateTypes || []
  })
}

/** 询价匹配供应商模板 */
export const matchSupplierQuotationTemplate = (params: SupplierQuotationTemplateMatchRequest) => {
  return http.post<SupplierQuotationTemplateVO>(`${BASE}/match-for-supplier`, params)
}
